import { Injectable } from '@angular/core';
import { KeycloakUserInfo, PaginatedResponse } from '@finxone-platform/shared/sys-config-types';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, catchError, tap } from 'rxjs';
import {
  AddProgressBarWorkflowStack,
  RemoveProgressBarWorkflowStack,
} from '../actions/progress-bar-workflow.action';
import { GetTeamMembers } from '../actions/team-members.action';
import { ApiService } from '../services/api-service/api.service';

export interface TeamMembersStateModel {
  totalPages: number;
  limit: number;
  result: KeycloakUserInfo[];
}

@State<TeamMembersStateModel>({
  name: 'teamMembers',
  defaults: {
    totalPages: 0,
    limit: 0,
    result: [],
  },
})
@Injectable()
export class TeamMembersState {
  constructor(private apiService: ApiService) {}

  @Selector()
  static getTeamMembers(state: TeamMembersStateModel) {
    return state;
  }

  @Action(GetTeamMembers)
  fetchTeamMembers(ctx: StateContext<TeamMembersStateModel>, action: GetTeamMembers) {
    ctx.dispatch(new AddProgressBarWorkflowStack({ uniqueId: 'GetTeamMembers' }));

    return this.apiService
      .getCall<PaginatedResponse<KeycloakUserInfo>>(`/user/admin-users`, {
        params: {
          page: action.payload.page,
          size: action.payload.size,
          query: action.payload.query,
        },
      })
      .pipe(
        tap((response: PaginatedResponse<KeycloakUserInfo>) => {
          ctx.dispatch(
            new RemoveProgressBarWorkflowStack({
              uniqueId: 'GetTeamMembers',
            }),
          );
          ctx.patchState({
            ...ctx.getState(),
            result: response.result,
            totalPages: response.totalPages,
            limit: response.limit,
          });
        }),
        catchError<unknown, Observable<boolean>>((_err) => {
          ctx.dispatch(
            new RemoveProgressBarWorkflowStack({
              uniqueId: 'GetTeamMembers',
            }),
          );
          throw _err;
        }),
      );
  }
}
